import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";
import { Search } from "lucide-react";

const CATEGORIES = [
  { v: "", l: "All" },
  { v: "residential", l: "Residential" },
  { v: "commercial", l: "Commercial" },
  { v: "dental", l: "Dental Clinics" },
  { v: "medical", l: "Medical Clinics" },
];

const Listings = () => {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ category: "", min_price: "", max_price: "", bedrooms: "", bathrooms: "", location: "", q: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const load = async () => {
    setLoading(true);
    const params = {};
    Object.entries(f).forEach(([k, v]) => { if (v !== "" && v !== null) params[k] = v; });
    try {
      const { data } = await api.get("/public/listings", { params });
      setList(data);
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-slate-50 min-h-screen" data-testid="listings-page">
      <section className="bg-navy text-white py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Browse</div>
          <h1 className="font-display text-4xl lg:text-5xl mt-3">All Listings</h1>
          <p className="mt-4 text-white/70 max-w-xl">Residential, commercial, dental, and medical properties curated by Forte.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 -mt-10 relative z-10">
        <div className="bg-white border border-slate-200 shadow-luxury p-6 lg:p-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            <div className="col-span-2 relative">
              <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input placeholder="Search title, location..." value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} className="w-full border border-slate-200 pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-search-q" />
            </div>
            <select value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold bg-white" data-testid="listings-filter-category">
              {CATEGORIES.map((c) => <option key={c.v} value={c.v}>{c.l}</option>)}
            </select>
            <input type="number" placeholder="Min $" value={f.min_price} onChange={(e) => setF({ ...f, min_price: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-filter-min" />
            <input type="number" placeholder="Max $" value={f.max_price} onChange={(e) => setF({ ...f, max_price: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-filter-max" />
            <input placeholder="Location" value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-filter-location" />
          </div>
          <div className="mt-3 grid grid-cols-2 md:grid-cols-6 gap-3">
            <input type="number" placeholder="Min beds" value={f.bedrooms} onChange={(e) => setF({ ...f, bedrooms: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-filter-beds" />
            <input type="number" placeholder="Min baths" value={f.bathrooms} onChange={(e) => setF({ ...f, bathrooms: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="listings-filter-baths" />
            <button onClick={load} className="btn-navy py-2.5 px-5 text-sm col-span-2 md:col-span-1" data-testid="listings-filter-submit">Apply Filters</button>
            <button onClick={() => { setF({ category: "", min_price: "", max_price: "", bedrooms: "", bathrooms: "", location: "", q: "" }); setTimeout(load, 50); }} className="text-sm text-slate-500 hover:text-navy md:col-span-1" data-testid="listings-filter-reset">Reset</button>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        {loading ? (
          <div className="text-center py-20 text-slate-500">Loading listings...</div>
        ) : list.length === 0 ? (
          <div className="text-center py-20 text-slate-500" data-testid="listings-empty">No listings match your filters.</div>
        ) : (
          <>
            <div className="text-sm text-slate-500 mb-6">Showing {list.length} properties</div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="listings-grid">
              {list.map((l) => <ListingCard key={l.id} l={l} />)}
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default Listings;
